import React, { useEffect, useState } from "react";
import RecentModelItem from "./RecentModelItem";
import { DashboardViewType } from "../../../helper/constant";
import { getCustomDashboard } from "../../../service/ai-model.service";
import { useAppContext } from "../../../context/app.context";

const CustomDashboard = () => {

    const { } = useAppContext();
    const [customDashboardList, setCustomDashboardList] = useState([]);
    useEffect(() => {
        getCustomDashboard()
            .then((response) => setCustomDashboardList(response))
            .catch((error) => error);
    }, []);

    const renderCustomDashboardList = () => {
        if (customDashboardList.length === 0) {
            return <p className="d-flex align-items-center justify-content-center">No records found</p>;
        }
        return customDashboardList.map((item) => (
            <RecentModelItem
                key={item.id}
                template={item}
                type="dashboard" variant={DashboardViewType.CUSTOM} />
        ));
    }

    const render = () => {
        return (
            <div className="row">
                <RecentModelItem
                    template={{ name: 'Impart AI' }}
                    type="dashboard" variant={DashboardViewType.IMPART} />
                {renderCustomDashboardList()}
            </div>
        );
    }
    return render();
}
export default CustomDashboard;